import { Reveal } from "./Reveal";
import { RuotaMark } from "./RuotaMark";

const TESTIMONIALS = [
  {
    quote: "Jill made our trip to Rio de Janeiro absolutely spectacular! From the perfect accommodations to the private excursions, every detail was thoughtfully planned. We enjoyed VIP treatment throughout and skipped the long lines. It easily ranks among our favorite travel experiences. Absolutely unforgettable!",
    name: "Tonya & Friends",
    trip: "Rio de Janeiro · Carnaval",
  },
  {
    quote: "Jill anticipates everything you could possibly need or know for a stress free and enjoyable vacation. Jill found us local tour guides who were all knowledgeable, accommodating and so much fun! I will plan all future trips via Jill. Thank YOU Jill!",
    name: "Mary",
    trip: "Europe",
  },
  {
    quote: "Planning a trip of a lifetime is no small feat, but Jill Bauman made it look effortless. I COULD HAVE NEVER EVER done this myself. No way. All we had to do was show up and enjoy every second. You've given us memories we'll cherish forever. (You have our loyalty for LIFE)",
    name: "Elena",
    trip: "50th Birthday in Italy",
  },
  {
    quote: "Jill Bauman created a fantastic itinerary for my trip to Spain. I simply gave her my dates along with one or two \"must sees\", and she took it from there. This was a complicated trip through Madrid, Salamanca, Rioja and San Sebastian. All her choices - hotels, activities, where to eat - were spot on. It saved me so much time! I will never book a trip without her again!",
    name: "Esther G.",
    trip: "Spain · San Sebastián",
  },
  {
    quote: "I can't say enough about the incredible experience Jill created with this trip to Italy and Switzerland. Every hotel, every restaurant, every excursion was absolutely perfect. I didn't have to worry about a thing. I just got to enjoy every second. If you ever have the chance to have her plan a trip for you, don't hesitate. You will be in the best hands!",
    name: "Teresa C.",
    trip: "Italy & Switzerland",
  },
  {
    quote: "Jill planned our 10 day honeymoon to Italy including Amalfi, Sorrento, Capri and Tuscany. She curated so many details including wine tours, hikes, amazing dinners and beautiful hotels. She got to know us and our travel goals and planned a seamless trip. Her communication was awesome and I cannot wait to book another trip with her. She was amazing!",
    name: "Mr. H.",
    trip: "Italy Honeymoon",
  },
];

const Card = ({ t, i }) => (
  <figure
    data-testid={`testimonial-card-${i + 1}`}
    className="flex w-[320px] shrink-0 flex-col rounded-2xl border-t-2 border-[#E2725B] bg-white p-6 shadow-sm sm:w-[380px]"
  >
    <blockquote className="font-display text-base font-light leading-relaxed text-[#13272B]">
      “{t.quote}”
    </blockquote>
    <figcaption className="mt-4">
      <p className="font-display text-base italic text-[#168A91]">{t.name}</p>
      <p className="mt-0.5 font-accent text-[10px] uppercase tracking-[0.25em] text-[#4A5557]">
        {t.trip}
      </p>
    </figcaption>
  </figure>
);

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="overflow-hidden bg-[#F7F0E3] py-20 sm:py-24">
    <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
      <Reveal>
        <div className="flex items-center gap-4">
          <RuotaMark size={26} duration={16} />
          <p className="font-display text-2xl font-medium uppercase tracking-[0.15em] text-[#E2725B] sm:text-3xl">
            In Their Words
          </p>
        </div>
      </Reveal>
    </div>

    <Reveal delay={0.1}>
      <div className="mt-10 overflow-hidden">
        <div className="animate-marquee flex w-max">
          {[0, 1].map((copy) => (
            <div key={copy} className="flex gap-6 pr-6">
              {TESTIMONIALS.map((t, i) => (
                <Card key={`${copy}-${t.name}`} t={t} i={i} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </Reveal>
  </section>
);
